module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-20-755f8c17bf3695e4e74104605aefd973.svg";